// // import React, { useState } from "react";
// // import ReactQuill from "react-quill";
// // import "react-quill/dist/quill.snow.css";
// // import "./TextEditor.css"; // Import your CSS file for styling
// // const Pop3 = () => {
// //   const [editorHtml, setEditorHtml] = useState("");

// //   const handleChange = (html) => {
// //     setEditorHtml(html);
// //   };

// //   const handleSubmit = () => {
// //     console.log("Submitted HTML:", editorHtml);
// //     alert("Submitted HTML:\n" + editorHtml);
// //   };

// //   // Flattened toolbar configuration with list and indent options included
// //   const modules = {
// //     toolbar: [
// //       ["bold", "italic", "underline"],
// //       [{ color: [] }],
// //       [{ list: "ordered" }, { list: "bullet" }],
// //       [{ indent: "-1" }, { indent: "+1" }]
// //     ]
// //   };

// //   // Ensure that "indent" is added to the formats array.
// //   const formats = [
// //     "bold",
// //     "italic",
// //     "underline",
// //     "color",
// //     "list",
// //     "bullet",
// //     "indent"
// //   ];

// //   return (
// //     <div>
// //       <div style={{ marginBottom: "4px" , marginTop:"2px" , color:"GrayText" }}>Instructions</div>
// //       <ReactQuill
// //         value={editorHtml}
// //         onChange={handleChange}
// //         modules={modules}
// //         formats={formats}
// //         placeholder="Write something..."
// //         style={{ minHeight: "200px" }}
// //       />
// //       {/* <button onClick={handleSubmit}>Submit</button>
// //       <h3>HTML Output Preview:</h3>
// //       <pre style={{ backgroundColor: "#f5f5f5", padding: "10px" }}>
// //         {editorHtml}
// //       </pre> */}
// //     </div>
// //   );
// // };

// // export default Pop3;

// import React, { useState, useMemo } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import "./TextEditor.css";
// import ImportImg from "../../../Assets/Images/CommanImages/fileexport.png";
// // Set a custom icon for the custom "importtemplate" button
// const icons = Quill.import("ui/icons");
// // icons["importtemplate"] = '<span style="font-weight:bold;">Imp</span>';
// icons[
//   "importtemplate"
// ] = `<img src="${ImportImg}" style="width:18px; height:18px; vertical-align:middle;" alt="Import" />`;
// const Pop3 = ({ templates = [] }) => {
//   const [editorHtml, setEditorHtml] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   const handleChange = (html: string) => {
//     setEditorHtml(html);
//   };

//   const handleTemplateClick = (templateHtml: string) => {
//     setEditorHtml(templateHtml);
//     setShowModal(false);
//   };

//   // ✅ Move both "modules" and the handler creation together inside useMemo
//   const modules = useMemo(() => {
//     return {
//       toolbar: {
//         container: [
//           ["bold", "italic", "underline"],
//           [{ color: [] }],
//           [{ list: "ordered" }, { list: "bullet" }],
//           [{ indent: "-1" }, { indent: "+1" }],
//           ["importtemplate"],
//         ],
//         handlers: {
//           importtemplate: () => setShowModal(true), // directly call setShowModal
//         },
//       },
//     };
//   }, []);

//   const formats = [
//     "bold",
//     "italic",
//     "underline",
//     "color",
//     "list",
//     "bullet",
//     "indent",
//   ];

//   return (
//     <div>
//       <div style={{ marginBottom: "4px", marginTop: "2px", color: "GrayText" }}>
//         Instructions
//       </div>
//       <ReactQuill
//         value={editorHtml}
//         onChange={handleChange}
//         modules={modules}
//         formats={formats}
//         placeholder="Write something..."
//         style={{ minHeight: "200px" }}
//       />
//       {/* Modal for selecting a template */}
//       {showModal && (
//         <div className="modal">
//           <div className="modal-content">
//             <h3>Select a Template</h3>
//             {templates.length > 0 ? (
//               <ul>
//                 {templates.map((template) => (
//                   <li
//                     key={template.id}
//                     onClick={() => handleTemplateClick(template.html)}
//                     style={{ cursor: "pointer", padding: "5px 0" }}
//                   >
//                     {template.name}
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p>No templates available.</p>
//             )}
//             <button onClick={() => setShowModal(false)}>Close</button>
//           </div>
//         </div>
//       )}
//     </div>

//   );
// };

// export default Pop3;

// import React, { useState, useMemo } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import "./TextEditor.css";
// import ImportImg from "../../../Assets/Images/CommanImages/fileexport.png";

// // Set a custom icon for the custom "importtemplate" button
// const icons = Quill.import("ui/icons");
// icons[
//   "importtemplate"
// ] = `<img src="${ImportImg}" style="width:18px; height:18px; vertical-align:middle;" alt="Import" />`;

// const Pop3 = ({ templates = [] }) => {
//   const [editorHtml, setEditorHtml] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   const handleChange = (html) => {
//     setEditorHtml(html);
//   };

//   const handleTemplateClick = (templateHtml) => {
//     setEditorHtml(templateHtml);
//     setShowModal(false);
//   };

//   const modules = useMemo(() => {
//     return {
//       toolbar: {
//         container: [
//           [
//             "bold",
//             "italic",
//             "underline",
//             { color: [] },
//             { list: "ordered" },
//             { list: "bullet" },
//             { indent: "-1" },
//             { indent: "+1" },
//           ],
//           [{ importtemplate: true }],
//         ],
//         handlers: {
//           importtemplate: () => setShowModal(true),
//         },
//       },
//     };
//   }, []);
  
//   // const modules = useMemo(() => {
//   //   return {
//   //     toolbar: {
//   //       container: [
//   //         ["bold", "italic", "underline"],
//   //         [{ color: [] }],
//   //         [{ list: "ordered" }, { list: "bullet" }],
//   //         [{ indent: "-1" }, { indent: "+1" }],
//   //         ["importtemplate"],
//   //       ],
//   //       handlers: {
//   //         importtemplate: () => setShowModal(true),
//   //       },
//   //     },
//   //   };
//   // }, []);

//   const formats = [
//     "bold",
//     "italic",
//     "underline",
//     "color",
//     "list",
//     "bullet",
//     "indent",
//   ];

//   return (
//     <div>
//       <div style={{ marginBottom: "4px", marginTop: "2px", color: "GrayText" }}>
//         Instructions
//       </div>
//       <ReactQuill
//         value={editorHtml}
//         onChange={handleChange}
//         modules={modules}
//         formats={formats}
//         placeholder="Write something..."
//         style={{ minHeight: "200px" }}
//       />
//       {/* Decorated Modal for selecting a template */}
//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.5)",
//             zIndex: 1000,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               padding: "20px",
//               borderRadius: "8px",
//               width: "80%",
//               maxWidth: "500px",
//               boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//               maxHeight: "80%",
//               overflowY: "auto",
//             }}
//           >
//             <h3 style={{ marginTop: 0 , marginBottom:"10px"}}>Select instructions</h3>
//             {templates.length > 0 ? (
//               <ul style={{ listStyle: "none", paddingLeft: 0 }}>
//                 {templates.map((template) => (
//                   <li
//                     key={template.test_inst_template_id}
//                     onClick={() =>
//                       handleTemplateClick(template.test_instruction_html)
//                     }
//                     style={{
//                       cursor: "pointer",
//                       padding: "10px",
//                       borderBottom: "1px solid #eee",
//                       marginBottom: "5px",
//                       border:"1px solid #ccc",
//                     }}
//                   >
//                     {template.test_inst_template_name}
//                     <br />
//                     <small style={{ color: "#666" }}>
//                       {template.test_template_desc}
//                     </small>
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p>No templates available.</p>
//             )}
//             <button
//               onClick={() => setShowModal(false)}
//               style={{
//                 marginTop: "20px",
//                 padding: "8px 16px",
//                 marginLeft: "0",
//                 cursor: "pointer",
//               }}
//               className="create-test-section-btn"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Pop3;

import React, { useState, useMemo, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./TextEditor.css";
import ImportImg from "../../../Assets/Images/CommanImages/fileexport.png";
import Colors from "../../../Constants/Colors";
// Set a custom icon for the custom "importtemplate" button
const icons = Quill.import("ui/icons");
icons["importtemplate"] = `<img src="${ImportImg}" style="width:18px; height:18px; vertical-align:middle;" alt="Import" />`;

const TextEditor = ({ templates = [], value = "", setValue }) => {
  // Initialize editor state from the passed value
  const [editorHtml, setEditorHtml] = useState(value);
  const [showModal, setShowModal] = useState(false);

  // Update local state if parent value changes
  useEffect(() => {
    setEditorHtml(value);
  }, [value]);

  const handleChange = (html) => {
    setEditorHtml(html);
    // Pass the updated HTML up if setValue is provided
    if (setValue) {
      setValue(html);
    }
  };

  const handleTemplateClick = (templateHtml) => {
    setEditorHtml(templateHtml);
    if (setValue) {
      setValue(templateHtml);
    }
    setShowModal(false);
  };

  const modules = useMemo(() => {
    return {
      toolbar: {
        container: [
          [
            "bold",
            "italic",
            "underline",
            { color: [] },
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          [{ importtemplate: true }],
        ],
        handlers: {
          importtemplate: () => setShowModal(true),
        },
      },
    };
  }, []);

  const formats = [
    "bold",
    "italic",
    "underline",
    "color",
    "list",
    "bullet",
    "indent",
  ];

  return (
    <div>
      <div style={{ marginBottom: "4px", marginTop: "2px", color: "GrayText" }}>
        Instructions <span style={{color:`${Colors.color15}`}}>*</span>
      </div>
      <ReactQuill
        value={editorHtml}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Write something..."
        style={{ minHeight: "200px" }}
      />
      {/* Decorated Modal for selecting a template */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "80%",
              maxWidth: "500px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom:"10px" }}>Select instructions</h3>
            {templates.length > 0 ? (
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {templates.map((template) => (
                  <li
                    key={template.test_inst_template_id}
                    onClick={() => handleTemplateClick(template.test_instruction_html)}
                    style={{
                      cursor: "pointer",
                      padding: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      border: "1px solid #ccc",
                    }}
                  >
                    {template.test_inst_template_name}
                    <br />
                    <small style={{ color: "#666" }}>
                      {template.test_template_desc}
                    </small>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No templates available.</p>
            )}
            <button
              onClick={() => setShowModal(false)}
              style={{
                marginTop: "20px",
                padding: "8px 16px",
                marginLeft: "0",
                cursor: "pointer",
              }}
              className="create-test-section-btn"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextEditor;